namespace Areas.Project.Upload {
    "use strict";

    export function fileUploaderInitialized(e: any) {
        const fileUploader = e.component;
        const uploadAllowed = fileUploader.option("UploadAllowed");
        const projectId = fileUploader.option("ProjectId");
        const attachmentType = fileUploader.option("AttachmentType");

        const enable = uploadAllowed && isValidNumber(projectId) && Areas.isNotEmpty(attachmentType);
        
        associateUploadWithValue("projectId", projectId);

        if (enable) {
            associateUploadWithValue("attachmentType", attachmentType);
        }
    }

    export function refreshGrid(e: any) {
        if ($("#SharedBaseGrid").dxDataGrid("instance")) {
            Areas.refreshGrid("SharedBaseGrid");
        };
        
        if ($("#OtherAttachmentGrid").dxDataGrid("instance")) {
            Areas.refreshGrid("OtherAttachmentGrid");
        };
 
    }

    export function associateUploadWithValue(valueIdentifier:string, value: any) {
        const uploader = $("#fileUploaderControl").dxFileUploader("instance");
        if (uploader) {
            let url: any = uploader.option("uploadUrl");

            if (isValid(value)) {
                url = updateQueryStringParameter(url, valueIdentifier, value);
            } else {
                url = removeQueryStringParameter(url, valueIdentifier);
            }
    
            updateUploader(uploader, url);
        }
    } 

    function isValid(value: any) : boolean {
        var numericValue = Number(value);

        if (isNaN(numericValue)) {
            return Areas.isNotEmpty(value);
        }

        return numericValue > 0;
    }


    function updateUploader(uploader: DevExpress.ui.dxFileUploader, url: string) {
        const uploadAllowed = uploader.option("UploadAllowed");
        const canEnable = uploadAllowed && url.indexOf("projectId") > -1 && url.indexOf("attachmentType") > -1;

        if (canEnable) {
            uploader.option("disabled", false);
        } else {
            uploader.option("disabled", true);
        }

        uploader.option("uploadUrl", url);        
    }

    function isValidNumber(value: any) : boolean {
        var numericValue = Number(value);

        if (isNaN(numericValue)) {
            return Areas.isNotEmpty(value);
        }

        return numericValue > 0;
    }

    export function uploadError(e: any) {
        const defaultTimeOut = 4000;

        const responseText = e.request.responseText;

        const toastrOptions = { timeOut: defaultTimeOut, positionClass: "toast-bottom-full-width", showMethod: "show" };
        toastr.error(responseText, "Error", toastrOptions);
    }
}